module.exports = require("./sah.d.ts");